'use strict';
const defaults = require('./defaults'),
	envConfig = require('./staging'),
	storageConfig = require('./aws'),
	config = {
		microsoftAppId: 'ef9b3427-781e-442f-9713-ef6ee99f2d04',
		CDNDistributionId: 'E1UCUMRYHZNOZ0',
		cognito: {
			cognitoIdentityPoolId: 'us-east-1:1768e4ed-1bac-4994-9800-c72838f95cd4',
			UserPoolId: 'us-east-1_X8SF1gGP1',
			ClientId: '47992dflkijdb4i6hq3to5f02e'
		}
	};
module.exports = Object.assign({}, defaults, storageConfig, envConfig, config);
